import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fields"],
    _excluded2 = ["fields", "title", "name"];
import React from 'react';
import PropTypes from 'prop-types';
import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
import Tabs from "antd/es/tabs/index.js";
var TabPane = Tabs.TabPane;

var FormTabs = function FormTabs(_ref) {
  var fields = _ref.fields,
      rest = _objectWithoutProperties(_ref, _excluded);

  var formOptions = useFormApi();
  return /*#__PURE__*/React.createElement(Tabs, rest, fields.map(function (_ref2) {
    var fields = _ref2.fields,
        title = _ref2.title,
        name = _ref2.name,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement(TabPane, _extends({
      tab: title,
      key: name
    }, rest, {
      forceRender: true
    }), formOptions.renderForm(fields, formOptions));
  }));
};

FormTabs.propTypes = {
  fields: PropTypes.array.isRequired
};
export default FormTabs;